import {
  default as MuiIcon,
  type IconProps as MuiIconProps,
} from '@mui/material/Icon';
export { iconClasses } from '@mui/material/Icon';

/**
 * @deprecated Unsupported component: This is an internal component, use UnifyIcons instead.
 * Please reach out to us in #unify-design-system-support if you have a use case for this component.
 */
export const Icon = MuiIcon;
/**
 * @deprecated Unsupported component: This is an internal component, use UnifyIcons instead.
 * Please reach out to us in #unify-design-system-support if you have a use case for this component.
 */
export type IconProps = MuiIconProps;
